
export { default as Modal } from "./components/Modal"